import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePCrmServiceCategory, PCrmServiceCategory } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<PCrmServiceCategory>
      useData={usePCrmServiceCategory}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
